import { useTheme } from "@mui/material";
import WoPrintOnFrontPage1 from "assets/print-templates/work-orders-po/front/WoPrintOnFront_Page1.jpg";
import WoPrintOnFrontPage2 from "assets/print-templates/work-orders-po/front/WoPrintOnFront_Page2.jpg";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";

import { IWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import {
  PrintMultiplePageItem,
  PrintMultiplePagePreview,
} from "share-components/templates/print/print-multiple-page-preview";
import { useFrontPage1Elements } from "./hooks/use-pront-page-1-elements";
import { useFrontPage2Elements } from "./hooks/use-pront-page-2-elements";

export const PrintOnFrontPreview = observer(() => {
  const {
    workOrderPoManagement: {
      workOrderPoPrintingManagement: { openPrintOnFrontPreview, setProp },
      workOrderPoDetail,
    },
  } = useStores();

  const theme = useTheme();

  const onCloseHandler = useCallback(() => {
    setProp("openPrintOnFrontPreview", false);
  }, [setProp]);

  const { frontPage1Elements } = useFrontPage1Elements({
    workOrderPoDetail: workOrderPoDetail as IWorkOrderPo,
  });

  const { frontPage2Elements } = useFrontPage2Elements({
    workOrderPoDetail: workOrderPoDetail as IWorkOrderPo,
  });

  const pages = useMemo<PrintMultiplePageItem[]>(() => {
    return [
      {
        key: "front-page-1",
        elements: frontPage1Elements,
        templateImage: WoPrintOnFrontPage1,
        backgroundSize: "100%",
        backgroundPosition: "inherit",
      },
      {
        key: "front-page-2",
        elements: frontPage2Elements,
        templateImage: WoPrintOnFrontPage2,
        backgroundSize: "100%",
        backgroundPosition: "inherit",
      },
    ];
  }, [frontPage1Elements, frontPage2Elements]);

  return (
    <PrintMultiplePagePreview
      open={openPrintOnFrontPreview}
      printIncludeTemplate={true}
      pages={pages}
      editorOptions={{
        enabled: true,
      }}
      mode="portrait"
      fontSize="16px"
      paperSize={{
        width: "21cm",
        height: "29.7cm",
      }}
      sx={{
        fontFamily: `"Times New Roman", Times, ${theme.typography.fontFamily} !important`,
      }}
      onClose={onCloseHandler}
    />
  );
});
